export interface SidebarState {
  type: SidebarType,
  item?: any;
  subItem?: any;
  title?: string;
  useHistory?: boolean;
  options?: SidebarOptions;
  size?: string;
}

export interface SidebarOptions {
  success?: boolean;
  reload?: boolean;
  mainPage?: boolean;
}

export enum SidebarType {
  None = "",
  SurveyQuestions = "SurveyQuestionsComponent",
  EmojiKey = "EmojiKeyComponent",
  SendNotification = "SendNotificationComponent",
  Participant = "ParticipantComponent",
  ResearchData = "ResearchDataComponent",
  WatchAssignment = "WatchAssignmentComponent",
  WatchStatistics = "WatchStatisticsComponent",
  CommercialParticipant = "CommercialParticipantComponent"
}

export enum PanelSize {
  sm = "350px",
  md = "550px",
  lg = "850px",
  xl = "1150px"
}